import axios from './axios'
import { ElLoading } from 'element-plus'
export function getAwardUser (callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get('/pos_front/award_user').then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function getPayment (callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get('/pos_front/payment').then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function noticePrint (taskID, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get('/pos_front/print/' + taskID).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
export function getGoodsPage (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/pos_front/goods_page', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
